import React, { useState, useEffect } from "react";

import { compileToDataSource } from "./utils";
import { OrgGroupAggregationMetricsData } from "../../../../models/ChartCollectionData";
import PieChartItem from "../../../DashboardComponents/PieChartItem";

import "./styles.scss";

export interface ICircleChartProps {
  chartDetailsData: OrgGroupAggregationMetricsData;
  chartId?: number;
}

/**
 * CircleChart - Pure chart component without controls
 * Only handles data processing and chart rendering
 * Controls (CSV download) should be added by container
 */
export const CircleChart: React.FunctionComponent<ICircleChartProps> = (
  props
) => {
  const { chartDetailsData, chartId } = props;

  const [chartData, setChartData] = useState<any[]>([]);

  useEffect(() => {
    if (!!chartDetailsData) {
      const chartDataTemp = compileToDataSource(chartDetailsData);
      setChartData(chartDataTemp);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chartDetailsData]);

  return (
    <div className="collection-chart-area-circle-chart">
      <div className="circle-chart-top-row">
        <div
          id={chartId ? `csv-download-${chartId}` : "csv-download"}
          className="csv-download"
        />
      </div>
      <div>
        <PieChartItem
          width={750}
          height={460}
          innerRadius={108}
          outerRadius={125}
          showLegend={true}
          sizeType={"bigger"}
          dataList={chartData.reverse()}
        />
      </div>
    </div>
  );
};

export default CircleChart;
